<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold">TRN_ID: {{studyTransactionModel.transactionId}} - STOCK_ID: {{studyTransactionModel.lot.stockId}}</h4>
        <button type="button" class="btn-close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <div class="table-responsive">
            <div class="custom-scroll-style" style="max-height: 400px; overflow-y: auto; overflow-x: auto;">
                <table class="table table-striped table-bordered table-curved" *ngIf="transactionObservationUnitModels.length else nodata">
                    <thead class="sticky-header">
                    <tr>
                        <th>TRIAL_INSTANCE</th>
                        <th>PLOT_NO</th>
                        <th>REP_NO</th>
                        <th>BLOCK_NO</th>
                        <th>PLOT_UUID</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let transactionObsUnit of transactionObservationUnitModels; trackBy: trackByObsUnitId">
                        <td>{{transactionObsUnit.instanceNo}}</td>
                        <td>{{transactionObsUnit.plotNo}}</td>
                        <td>{{transactionObsUnit.repNo}}</td>
                        <td>{{transactionObsUnit.blockNo}}</td>
                        <td>{{transactionObsUnit.obsUnitId}}</td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>106</td>
                        <td>2</td>
                        <td>15</td>
                        <td>d8f3a4e9-b7c1-4a52-9d68-f5e382c09b3d</td>
                    </tr>
                    <tr>
                        <td>4</td>
                        <td>107</td>
                        <td>1</td>
                        <td>16</td>
                        <td>a1b2c3d4-e5f6-4a52-9d68-g7h8i9j0k1l2</td>
                    </tr>
                    <tr>
                        <td>5</td>
                        <td>108</td>
                        <td>3</td>
                        <td>17</td>
                        <td>m3n4o5p6-q7r8-4a52-9d68-s9t0u1v2w3x4</td>
                    </tr>
                    <tr>
                        <td>6</td>
                        <td>109</td>
                        <td>2</td>
                        <td>18</td>
                        <td>y5z6a7b8-c9d0-4a52-9d68-e1f2g3h4i5j6</td>
                    </tr>
                    <tr>
                        <td>7</td>
                        <td>110</td>
                        <td>1</td>
                        <td>19</td>
                        <td>k7l8m9n0-o1p2-4a52-9d68-q3r4s5t6u7v8</td>
                    </tr>
                    <tr>
                        <td>8</td>
                        <td>111</td>
                        <td>3</td>
                        <td>20</td>
                        <td>w9x0y1z2-a3b4-4a52-9d68-c5d6e7f8g9h0</td>
                    </tr>
                    <tr>
                        <td>9</td>
                        <td>112</td>
                        <td>2</td>
                        <td>21</td>
                        <td>i1j2k3l4-m5n6-4a52-9d68-o7p8q9r0s1t2</td>
                    </tr>
                    <tr>
                        <td>10</td>
                        <td>113</td>
                        <td>1</td>
                        <td>22</td>
                        <td>u3v4w5x6-y7z8-4a52-9d68-a9b0c1d2e3f4</td>
                    </tr>
                    <tr>
                        <td>11</td>
                        <td>114</td>
                        <td>3</td>
                        <td>23</td>
                        <td>g5h6i7j8-k9l0-4a52-9d68-m1n2o3p4q5r6</td>
                    </tr>
                    <tr>
                        <td>12</td>
                        <td>115</td>
                        <td>2</td>
                        <td>24</td>
                        <td>s7t8u9v0-w1x2-4a52-9d68-y3z4a5b6c7d8</td>
                    </tr>
                    <tr>
                        <td>13</td>
                        <td>116</td>
                        <td>1</td>
                        <td>25</td>
                        <td>e9f0g1h2-i3j4-4a52-9d68-k5l6m7n8o9p0</td>
                    </tr>
                    <tr>
                        <td>14</td>
                        <td>117</td>
                        <td>3</td>
                        <td>26</td>
                        <td>q1r2s3t4-u5v6-4a52-9d68-w7x8y9z0a1b2</td>
                    </tr>
                    <tr>
                        <td>15</td>
                        <td>118</td>
                        <td>2</td>
                        <td>27</td>
                        <td>c3d4e5f6-g7h8-4a52-9d68-i9j0k1l2m3n4</td>
                    </tr>
                    <tr>
                        <td>16</td>
                        <td>119</td>
                        <td>1</td>
                        <td>28</td>
                        <td>o5p6q7r8-s9t0-4a52-9d68-u1v2w3x4y5z6</td>
                    </tr>
                    <tr>
                        <td>17</td>
                        <td>120</td>
                        <td>3</td>
                        <td>29</td>
                        <td>a7b8c9d0-e1f2-4a52-9d68-g3h4i5j6k7l8</td>
                    </tr>
                    <tr>
                        <td>18</td>
                        <td>121</td>
                        <td>2</td>
                        <td>30</td>
                        <td>m9n0o1p2-q3r4-4a52-9d68-s5t6u7v8w9x0</td>
                    </tr>
                    <tr>
                        <td>19</td>
                        <td>122</td>
                        <td>1</td>
                        <td>31</td>
                        <td>y1z2a3b4-c5d6-4a52-9d68-e7f8g9h0i1j2</td>
                    </tr>
                    <tr>
                        <td>20</td>
                        <td>123</td>
                        <td>3</td>
                        <td>32</td>
                        <td>k3l4m5n6-o7p8-4a52-9d68-q9r0s1t2u3v4</td>
                    </tr>
                    <tr>
                        <td>21</td>
                        <td>124</td>
                        <td>2</td>
                        <td>33</td>
                        <td>w5x6y7z8-a9b0-4a52-9d68-c1d2e3f4g5h6</td>
                    </tr>
                    <tr>
                        <td>22</td>
                        <td>125</td>
                        <td>1</td>
                        <td>34</td>
                        <td>i7j8k9l0-m1n2-4a52-9d68-o3p4q5r6s7t8</td>
                    </tr>
                    <tr>
                        <td>23</td>
                        <td>126</td>
                        <td>3</td>
                        <td>35</td>
                        <td>u9v0w1x2-y3z4-4a52-9d68-a5b6c7d8e9f0</td>
                    </tr>
                    <tr>
                        <td>24</td>
                        <td>127</td>
                        <td>2</td>
                        <td>36</td>
                        <td>g1h2i3j4-k5l6-4a52-9d68-m7n8o9p0q1r2</td>
                    </tr>
                    <tr>
                        <td>25</td>
                        <td>128</td>
                        <td>1</td>
                        <td>37</td>
                        <td>s3t4u5v6-w7x8-4a52-9d68-y9z0a1b2c3d4</td>
                    </tr>
                    <tr>
                        <td>26</td>
                        <td>129</td>
                        <td>3</td>
                        <td>38</td>
                        <td>e5f6g7h8-i9j0-4a52-9d68-k1l2m3n4o5p6</td>
                    </tr>
                    <tr>
                        <td>27</td>
                        <td>130</td>
                        <td>2</td>
                        <td>39</td>
                        <td>q7r8s9t0-u1v2-4a52-9d68-w3x4y5z6a7b8</td>
                    </tr>
                    <tr>
                        <td>28</td>
                        <td>131</td>
                        <td>1</td>
                        <td>40</td>
                        <td>c9d0e1f2-g3h4-4a52-9d68-i5j6k7l8m9n0</td>
                    </tr>
                    <tr>
                        <td>29</td>
                        <td>132</td>
                        <td>3</td>
                        <td>41</td>
                        <td>o1p2q3r4-s5t6-4a52-9d68-u7v8w9x0y1z2</td>
                    </tr>
                    <tr>
                        <td>30</td>
                        <td>133</td>
                        <td>2</td>
                        <td>42</td>
                        <td>a3b4c5d6-e7f8-4a52-9d68-g9h0i1j2k3l4</td>
                    </tr>
                    <tr>
                        <td>31</td>
                        <td>134</td>
                        <td>1</td>
                        <td>43</td>
                        <td>m5n6o7p8-q9r0-4a52-9d68-s1t2u3v4w5x6</td>
                    </tr>
                    <tr>
                        <td>32</td>
                        <td>135</td>
                        <td>3</td>
                        <td>44</td>
                        <td>y7z8a9b0-c1d2-4a52-9d68-e3f4g5h6i7j8</td>
                    </tr>
                    <tr>
                        <td>33</td>
                        <td>136</td>
                        <td>2</td>
                        <td>45</td>
                        <td>k9l0m1n2-o3p4-4a52-9d68-q5r6s7t8u9v0</td>
                    </tr>
                    <tr>
                        <td>34</td>
                        <td>137</td>
                        <td>1</td>
                        <td>46</td>
                        <td>w1x2y3z4-a5b6-4a52-9d68-c7d8e9f0g1h2</td>
                    </tr>
                    <tr>
                        <td>35</td>
                        <td>138</td>
                        <td>3</td>
                        <td>47</td>
                        <td>i3j4k5l6-m7n8-4a52-9d68-o9p0q1r2s3t4</td>
                    </tr>
                    <tr>
                        <td>36</td>
                        <td>139</td>
                        <td>2</td>
                        <td>48</td>
                        <td>u5v6w7x8-y9z0-4a52-9d68-a1b2c3d4e5f6</td>
                    </tr>
                    <tr>
                        <td>37</td>
                        <td>140</td>
                        <td>1</td>
                        <td>49</td>
                        <td>g7h8i9j0-k1l2-4a52-9d68-m3n4o5p6q7r8</td>
                    </tr>
                    <tr>
                        <td>38</td>
                        <td>141</td>
                        <td>3</td>
                        <td>50</td>
                        <td>s9t0u1v2-w3x4-4a52-9d68-y5z6a7b8c9d0</td>
                    </tr>
                    <tr>
                        <td>39</td>
                        <td>142</td>
                        <td>2</td>
                        <td>51</td>
                        <td>e1f2g3h4-i5j6-4a52-9d68-k7l8m9n0o1p2</td>
                    </tr>
                    <tr>
                        <td>40</td>
                        <td>143</td>
                        <td>1</td>
                        <td>52</td>
                        <td>q3r4s5t6-u7v8-4a52-9d68-w9x0y1z2a3b4</td>
                    </tr>
                    <tr>
                        <td>41</td>
                        <td>144</td>
                        <td>3</td>
                        <td>53</td>
                        <td>c5d6e7f8-g9h0-4a52-9d68-i1j2k3l4m5n6</td>
                    </tr>
                    <tr>
                        <td>42</td>
                        <td>145</td>
                        <td>2</td>
                        <td>54</td>
                        <td>o7p8q9r0-s1t2-4a52-9d68-u3v4w5x6y7z8</td>
                    </tr>
                    <tr>
                        <td>43</td>
                        <td>146</td>
                        <td>1</td>
                        <td>55</td>
                        <td>a9b0c1d2-e3f4-4a52-9d68-g5h6i7j8k9l0</td>
                    </tr>
                    <tr>
                        <td>44</td>
                        <td>147</td>
                        <td>3</td>
                        <td>56</td>
                        <td>m1n2o3p4-q5r6-4a52-9d68-s7t8u9v0w1x2</td>
                    </tr>
                    <tr>
                        <td>45</td>
                        <td>148</td>
                        <td>2</td>
                        <td>57</td>
                        <td>y3z4a5b6-c7d8-4a52-9d68-e9f0g1h2i3j4</td>
                    </tr>
                    <tr>
                        <td>46</td>
                        <td>149</td>
                        <td>1</td>
                        <td>58</td>
                        <td>k5l6m7n8-o9p0-4a52-9d68-q1r2s3t4u5v6</td>
                    </tr>
                    <tr>
                        <td>47</td>
                        <td>150</td>
                        <td>3</td>
                        <td>59</td>
                        <td>w7x8y9z0-a1b2-4a52-9d68-c3d4e5f6g7h8</td>
                    </tr>
                    <tr>
                        <td>48</td>
                        <td>151</td>
                        <td>2</td>
                        <td>60</td>
                        <td>i9j0k1l2-m3n4-4a52-9d68-o5p6q7r8s9t0</td>
                    </tr>
                    <tr>
                        <td>49</td>
                        <td>152</td>
                        <td>1</td>
                        <td>61</td>
                        <td>u1v2w3x4-y5z6-4a52-9d68-a7b8c9d0e1f2</td>
                    </tr>
                    <tr>
                        <td>50</td>
                        <td>153</td>
                        <td>3</td>
                        <td>62</td>
                        <td>g3h4i5j6-k7l8-4a52-9d68-m9n0o1p2q3r4</td>
                    </tr>
                    </tbody>
                </table>
                <ng-template #nodata>
                    <table class="table table-striped table-bordered table-curved">
                        <thead class="sticky-header">
                        <tr>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td jhiTranslate="no.data"></td>
                        </tr>
                        </tbody>
                    </table>
                </ng-template>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary" (click)="proceed()">{{ 'ok' | translate }}</button>
    </div>
</div>
